import { MapPin } from 'lucide-react';
import styles from './LocationButton.module.css';

export function LocationButton({ onFetch, loading = false, hidden = false }) {
    if (hidden) return null;
    return (
        <button
            className={styles['location-btn']}
            onClick={onFetch}
            disabled={loading}
            title="Hent pollendata baseret på din lokation"
        >
            <MapPin size={16} />
            {loading ? 'Henter position...' : 'Brug min lokation'}
        </button>
    );
}
